import { render, staticRenderFns } from "./DiffTextCard.vue?vue&type=template&id=6978302c"
import script from "./DiffTextCard.vue?vue&type=script&lang=js"
export * from "./DiffTextCard.vue?vue&type=script&lang=js"
import style0 from "./DiffTextCard.vue?vue&type=style&index=0&id=6978302c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports